import bottomLeftFallback from "@/assets/bottom-left.webp?w=400&quality=75&format=webp";
import bottomLeftAvif from "@/assets/bottom-left.webp?w=400;560&format=avif&quality=55&as=srcset";
import bottomLeft from "@/assets/bottom-left.webp?w=400;560&format=webp&quality=75&as=srcset";

import topRightFallback from "@/assets/top-right.webp?w=480&quality=75&format=webp";
import topRightAvif from "@/assets/top-right.webp?w=480;680&format=avif&quality=55&as=srcset";
import topRight from "@/assets/top-right.webp?w=480;680&format=webp&quality=75&as=srcset";

function BackgroundOrnaments() {
  return (
    <>
      <picture>
        <source
          type="image/avif"
          srcSet={topRightAvif}
          sizes="(min-width: 768px) 480px, 28vw"
        />
        <img
          src={topRightFallback}
          srcSet={topRight}
          sizes="(min-width: 768px) 480px, 28vw"
          className="pointer-events-none absolute top-0 -right-15  w-[clamp(180px,28vw,480px)]"
          aria-hidden="true"
          loading="eager"
          fetchPriority="low"
          alt=""
        />
      </picture>
      <picture>
        <source
          type="image/avif"
          srcSet={bottomLeftAvif}
          sizes="(min-width: 768px) 400px, 23vw"
        />
        <img
          src={bottomLeftFallback}
          srcSet={bottomLeft}
          sizes="(min-width: 768px) 400px, 23vw"
          className="pointer-events-none absolute bottom-0 -left-15  w-[clamp(180px,23vw,400px)]"
          aria-hidden="true"
          loading="lazy"
          fetchPriority="low"
          alt=""
        />
      </picture>
    </>
  );
}

export default BackgroundOrnaments;
